import React from "react";
import serverErrorIcon from '../assets/img/global/serverErrorIcon.png';
import '../assets/css/error.scss'
import constants from "../lib/constants/constants";

const ServerError = () => {
	return(
		<div id="error" className="dashboard-error">
		<section className="error-box">
			<p><img src={serverErrorIcon} alt="error"/></p>
			<p>
				<strong>서비스 이용에 불편을 드려 죄송합니다.</strong>
				<span>현재 서비스에 일시적인 오류가 발생하여 요청하신 페이지를 찾을 수 없어요. <br/>다시 시도해주세요.</span>
			</p>
			<button className="btn" onClick={()=>window.location.href=constants.URL.LIST}>장소 리스트로 이동</button>
		</section>
	</div>
	);
}

export default ServerError;